import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IMfaSetupResponse, IUserDetails } from '../../../interfaces/security.interfaces';
import { SecurityService } from '../../../services/security.service';
import { ILoginMfa } from '../../../interfaces/login.interface';

@Component({
  selector: 'com-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss'],
})
export class MfaSetupComponent implements OnInit {
  @Output() completed = new EventEmitter<boolean>();

  user: IUserDetails;
  mfa: IMfaSetupResponse;
  mfaGroup: FormGroup<ILoginMfa>;

  qrWidth: number = 256;
  qrErrorCorrectionLevel: string = 'M';

  mfaLoading: boolean = true;

  constructor(
    private security: SecurityService,
    private readonly fb: FormBuilder
  ) {}

  async ngOnInit(): Promise<void> {
    this.mfaGroup = this.fb.group<ILoginMfa>({
      authCode: this.fb.control<string>('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });

    this.user = this.security.profile.user;
    if (this.user) {
      await this.security.requestMfaDetails().then((response) => {
        this.mfa = response;
        this.mfaLoading = false;
      });
    }
  }

  async confirmAuthCode(value: any): Promise<void> {
    await this.security
      .confirmMfaCode(value.authCode)
      .then((response) => {
        if (response.confirmed) {
          this.completed.emit(true);
        } else {
          let authCodeControl: any = this.mfaGroup.controls.authCode;
          if (authCodeControl) {
            authCodeControl.setValue('');
            authCodeControl.setErrors({ incorrect: true });
          }
        }
      })
      .catch((err) => {
        let authCodeControl: any = this.mfaGroup.controls.authCode;
        if (authCodeControl) {
          authCodeControl.setValue('');
          authCodeControl.setErrors({ incorrect: true });
        }
      });
  }

  get authCode(): FormControl<string> {
    return this.mfaGroup.controls.authCode;
  }

  skipMfaSetup(): void {
    if (this.completed) this.completed.emit(true);
  }

  cancelLogIn() {
    this.security.logout();
  }
}
